import { Component } from '@angular/core';
import { HereMapComponent } from '../here-map/here-map.component';
import { MappositionComponent } from '../mapposition/mapposition.component';


@Component({
  selector: 'lib-here-map-base',
  standalone: true,
  imports: [HereMapComponent, MappositionComponent], // Adds MappositionComponent to the AppComponent template
  templateUrl: './here-map-base.component.html'
})
export class HereMapBaseComponent {
  zoom: number;
  lat: number;
  lng: number;

  /** Initialized by the constructor, these properties store the current zoom level and coordinates (latitude and longitude) for the map */
  constructor() {
    this.zoom = 9;
    this.lat = 38.464622;
    this.lng = -101.624108;
  }

  /** Updates the zoom, lat, and lng properties based on user input. */ 
  handleInputChange(event: Event) {
    const target = <HTMLInputElement> event.target;
    if (target) {
      if (target.name === 'zoom') {
        this.zoom = parseFloat(target.value);
      }
      if (target.name === 'lat') {
        this.lat = parseFloat(target.value);
      }
      if (target.name === 'lng') {
        this.lng = parseFloat(target.value);
      }
    }
  }
  
  /** Updates the zoom, lat, and lng properties based on user input. */ 
   handleMapChange(event: H.map.ChangeEvent) {
    if (event.newValue.lookAt) {
      const lookAt = event.newValue.lookAt;
      this.zoom = lookAt.zoom;
      this.lat = lookAt.position.lat;
      this.lng = lookAt.position.lng;
    }
  }
}
